module.exports = __webpack_public_path__ + "img/gallery13.f5c20949.png";